import { CategoryGuids, PaymentCategories } from '../../core/constants'
import { MonthlyCategoryTotals } from '../../core'
import { StackedLineChartData } from '../../core/utils/TrendsUtil'

type TotalsData = MonthlyCategoryTotals | StackedLineChartData

export const isIncome = (totals: TotalsData) => {
  return (
    (totals.top_level_category_guid === CategoryGuids.INCOME ||
      totals.category_guid === CategoryGuids.INCOME) &&
    !isInvestment(totals)
  )
}

export const isExpense = (totals: TotalsData) => {
  return !isIncome(totals) && !isTransfer(totals)
}

export const isPayment = (totals: TotalsData) => {
  return (
    PaymentCategories.includes(totals.top_level_category_guid) ||
    PaymentCategories.includes(totals.category_guid)
  )
}

export const isTransfer = (totals: TotalsData) => {
  return (
    totals.top_level_category_guid === CategoryGuids.TRANSFER ||
    totals.category_guid === CategoryGuids.TRANSFER
  )
}

export const isInvestment = (totals: TotalsData) => {
  return (
    totals.top_level_category_guid === CategoryGuids.INVESTMENTS ||
    totals.category_guid === CategoryGuids.INVESTMENTS
  )
}

export const isSpend = (totals: TotalsData) => {
  return !isIncome(totals) && !isTransfer(totals) && !isInvestment(totals)
}

export const getTopLevelCategoryTotals = (
  totals: (MonthlyCategoryTotals | StackedLineChartData)[],
) => {
  return totals.filter((item) => item.category_guid === item.top_level_category_guid)
}

export const calculateRelativeChange = (current: number, previous: number) => {
  if (previous === 0) return 0
  const change = (current - previous) / previous
  return isNaN(change) ? 0 : change
}
